import { create } from "@kodingdotninja/use-tailwind-breakpoint";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../../tailwind.config";
var config = resolveConfig(tailwindConfig);
export var useBreakpoint = create(config.theme.screens).useBreakpoint;
